exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dropdown-menu {\n  max-height: 300px !important;\n  overflow-y: auto !important;\n}\n\ninput:read-only {\n  color: white !important;\n  opacity: 0.2 !important;\n  background-color: black !important;\n}\n\ntd {\n  height: 50px !important;\n  vertical-align: middle !important;\n}\n\n.capital-table td:has(input) {\n  width: 100px !important;\n}\n\n.capital-table tr td {\n  text-align: center;\n}\n\n.capital-table tr td:first-child {\n  text-align: left;\n}\n\n.capital-table.capital-year-table td {\n  text-align: center !important;\n}\n\n.rwa-table thead,\n.rwa-table tbody {\n  display: block !important;\n}\n\n.rwa-table tbody {\n  overflow-x: auto !important;\n}\n\n.rwa-table tr td {\n  min-width: 150px !important;\n  text-align: center;\n}\n\n.rwa-table tr td:first-child {\n  min-width: 300px !important;\n  text-align: left;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/resolve-url-loader!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/pages/CapitalPlanning/Dashboard/style.scss
// module id = 1086
// module chunks = 0